import React from 'react';

export const Settings: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Configurações</h1>
        <p className="text-gray-600">Configurações globais do sistema</p>
      </div>

      <div className="card">
        <p className="text-gray-600">Funcionalidade em desenvolvimento...</p>
      </div>
    </div>
  );
};

